import bowser from 'bowser';

export const browser = bowser.getParser(window.navigator.userAgent);

export const isInvalidBrowser = browser.satisfies({
  'Microsoft Edge': '<10',
  'internet explorer': '<10',
});

if (isInvalidBrowser) {
  alert(
    `Desgraciadamente su navegador no es completamente soportado por este sitio`
  );
}

export const isIPhone = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

export const isIE11OrEdge = () => {
  return (
    browser.isBrowser('Microsoft Edge') ||
    (browser.isBrowser('Internet Explorer') &&
      browser.getBrowserVersion().startsWith('11'))
  );
};

export const isIE10 = () => {
  return (
    browser.isBrowser('Microsoft Edge') ||
    (browser.isBrowser('Internet Explorer') &&
      browser.getBrowserVersion().startsWith('10'))
  );
};
